import { render, staticRenderFns } from "./loyalty.vue?vue&type=template&id=a3cda354"
import script from "./loyalty.vue?vue&type=script&lang=js"
export * from "./loyalty.vue?vue&type=script&lang=js"
import style0 from "./loyalty.vue?vue&type=style&index=0&id=a3cda354&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports